// ink-component
import React from 'react';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { StyledSideNavGroups } from './styles';

export type SideNavGroupsProps = React.HTMLAttributes<HTMLUListElement>;

/**
 * @purpose Navigation list element (ul)
 * @group SideNav
 * @categories navigation
 * @HTMLType HTMLUListElement
 */
const SideNavGroups = React.forwardRef<HTMLUListElement, SideNavGroupsProps>((props, ref) => {
  const { className, style, ...otherProps } = props;
  const globalProps = getGlobalProps({});
  return <StyledSideNavGroups ref={ref} {...otherProps} {...globalProps} />;
});

SideNavGroups.displayName = 'SideNav.Groups';

export default SideNavGroups;
